const typographyModelEquipService = {
  true: 'Cadastrar Novo Serviço',
  false: 'Editar Serviço',
  warningTitle: 'Serviço desabilitado para este tipo de equipamento',
  warningText: 'Este serviço não está mais vinculado a este tipo de equipamento. No entanto, os históricos permanecem disponíveis nos equipamentos vinculados. Para consultá-los, acesse o equipamento desejado.',
};

export default typographyModelEquipService;
